exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".sortorder {\n  color: #c2c2c2  !important; }\n\n.sortorder.active {\n  color: #000000 !important; }\n\n.sortorder:after {\n  content: '\\25B2'; }\n\n.sortorder.active.reverse:after {\n  content: '\\25BC'; }\n\n.date-time-width {\n  width: 15% !important; }\n\n.location-hold-dd-section .multi-select span.multiSelect button#multi-select-button {\n  width: 100%;\n  text-align: left;\n  min-height: 45px !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/branch_management/components/location_holds/location_holds.scss
// module id = 998
// module chunks = 1